module.exports = __webpack_public_path__ + "static/media/list.efbc9ecf.png";